import { v4 } from 'uuid'

import {
  ADD_FILE_SUCCESS,
  CLOSE_MORE_INFO_DIALOG,
  CREATE_CFMP,
  CREATE_CFMP_ERROR,
  CREATE_CFMP_SUCCESS,
  GET_ADMINISTRATIVE_ACT_TYPES,
  GET_ADMINISTRATIVE_ACT_TYPES_ERROR,
  GET_ADMINISTRATIVE_ACT_TYPES_SUCCESS,
  GET_CURRENCIES,
  GET_CURRENCIES_ERROR,
  GET_CURRENCIES_SUCCESS,
  GET_PROCEDURE_TYPES,
  GET_PROCEDURE_TYPES_ERROR,
  GET_PROCEDURE_TYPES_SUCCESS,
  GET_REASON_TYPES,
  GET_REASON_TYPES_ERROR,
  GET_REASON_TYPES_SUCCESS,
  OPEN_MORE_INFO_DIALOG,
  REMOVE_FILE_SUCCESS,
  RESET_CFMP
} from './Cfmp.actions'

const initialState = {
  administrativeActTypes: { data: [], error: null, loading: true },
  attachedFiles: [],
  currencies: { data: [], error: null, loading: true },
  procedureTypes: { data: [], error: null, loading: true },
  reasonTypes: { data: [], error: null, loading: true },
  showMoreInfoDialog: false,
  submit: {
    cfmp: {
      amount: '',
      code: '',
      createdAt: '',
      reason: '',
      rut: '',
      supplier: ''
    },
    error: null,
    loading: false,
    success: false
  }
}

/**
 * The Cfmp reducer.
 */
export const cfmpReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case ADD_FILE_SUCCESS: {
      return {
        ...state,
        attachedFiles: state.attachedFiles.concat({ id: v4(), ...payload })
      }
    }

    case CLOSE_MORE_INFO_DIALOG: {
      return { ...state, showMoreInfoDialog: false }
    }

    case CREATE_CFMP: {
      return {
        ...state,
        submit: { cfmp: initialState.submit.cfmp, error: null, loading: true, success: false }
      }
    }
    case CREATE_CFMP_ERROR: {
      return {
        ...state,
        submit: {
          cfmp: initialState.submit.cfmp,
          error: payload.error,
          loading: false,
          success: false
        }
      }
    }
    case CREATE_CFMP_SUCCESS: {
      return {
        ...state,
        submit: { cfmp: payload.cfmp, error: null, loading: false, success: true }
      }
    }

    case GET_ADMINISTRATIVE_ACT_TYPES: {
      return { ...state, administrativeActTypes: { data: [], error: null, loading: true } }
    }
    case GET_ADMINISTRATIVE_ACT_TYPES_ERROR: {
      return {
        ...state,
        administrativeActTypes: { data: [], error: payload.error, loading: false }
      }
    }
    case GET_ADMINISTRATIVE_ACT_TYPES_SUCCESS: {
      return {
        ...state,
        administrativeActTypes: {
          data: payload.administrativeActTypes,
          error: null,
          loading: false
        }
      }
    }

    case GET_CURRENCIES: {
      return { ...state, currencies: { data: [], error: null, loading: true } }
    }
    case GET_CURRENCIES_ERROR: {
      return { ...state, currencies: { data: [], error: payload.error, loading: false } }
    }
    case GET_CURRENCIES_SUCCESS: {
      return { ...state, currencies: { data: payload.currencies, error: null, loading: false } }
    }

    case GET_PROCEDURE_TYPES: {
      return { ...state, procedureTypes: { data: [], error: null, loading: true } }
    }
    case GET_PROCEDURE_TYPES_ERROR: {
      return { ...state, procedureTypes: { data: [], error: payload.error, loading: false } }
    }
    case GET_PROCEDURE_TYPES_SUCCESS: {
      return {
        ...state,
        procedureTypes: { data: payload.procedureTypes, error: null, loading: false }
      }
    }

    case GET_REASON_TYPES: {
      return { ...state, reasonTypes: { data: [], error: null, loading: true } }
    }
    case GET_REASON_TYPES_ERROR: {
      return { ...state, reasonTypes: { data: [], error: payload.error, loading: false } }
    }
    case GET_REASON_TYPES_SUCCESS: {
      return { ...state, reasonTypes: { data: payload.reasonTypes, error: null, loading: false } }
    }

    case OPEN_MORE_INFO_DIALOG: {
      return { ...state, showMoreInfoDialog: true }
    }

    case REMOVE_FILE_SUCCESS: {
      return {
        ...state,
        attachedFiles: state.attachedFiles.filter(file => file.id !== payload.id)
      }
    }

    case RESET_CFMP: {
      return {
        ...state,
        attachedFiles: [],
        submit: initialState.submit
      }
    }

    default: {
      return state
    }
  }
}
